/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment } from '@wordpress/element';
import { InspectorControls, BlockControls, AlignmentControl, PanelColorSettings } from '@wordpress/block-editor';
import { ToggleControl, PanelBody } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { textAlign, reviewColor } = attributes;
	
	const colorSettings = [
		{
			value: reviewColor,
			onChange: colorValue => setAttributes({ reviewColor: colorValue }),
			label: __( 'Review Color', 'wp-travel-blocks' )
		}
	];
	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<BlockControls>
					<AlignmentControl
						value={textAlign}
						onChange={ ( nextAlign ) => {
							setAttributes( { textAlign: nextAlign } );
						} }
					/>
					<InspectorControls>
						<PanelColorSettings
							title={__('Colors', 'wp-travel-blocks')}
							colorSettings={colorSettings}
							initialOpen={false}
						/>
					</InspectorControls>
				</BlockControls>
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/trip-rating"
				attributes={ props.attributes }
			/>
		</div>
	);
}
